import React from 'react';
import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import styles from '../styles/review-detail-row.module.scss';

function ReviewDetailRow({ label, value }) {
    const isNode = React.isValidElement(value);
    const display = value === null || value === undefined || value === '' ? '—' : value;

    return (
        <div className={styles.row}>
            <Text as={TextAs.SPAN} size={TextSizes.SMALL} className={styles.label}>
                {label}
            </Text>
            {isNode ? (
                <span className={styles.value}>{display}</span>
            ) : (
                <Text as={TextAs.SPAN} size={TextSizes.SMALL} className={styles.value}>
                    {display}
                </Text>
            )}
        </div>
    );
}

export default ReviewDetailRow;
